// Locale-INDEPENDENT date/time formatting for MACHINE use (#4204).
//
// Stable ids, data keys, log lines, and internal values that get parsed back
// must NOT localize — their output is fixed regardless of the ambient/global
// Luxon locale. This is the deliberate counterpart of the DISPLAY helpers in
// date-format.ts: keeping the two apart means the display-vs-machine intent is
// visible in the function name (and enforced by the formatting-boundary guard),
// not left for a reviewer to remember. See design-docs/date-time-localization.md.

import { DateTime } from 'luxon';

/** Stable "yyyy-MM" month key (a data key / id) — never localized. */
export function formatMonthKey(dt: DateTime): string {
  return dt.toFormat('yyyy-MM');
}

/** Parse a stable "yyyy-MM" month key back to a DateTime in UTC. */
export function parseMonthKey(key: string): DateTime {
  return DateTime.fromFormat(key, 'yyyy-MM', { zone: 'utc' });
}

/**
 * Fixed "HH:mm" 24-hour time. Use for an internal value that is parsed back
 * (e.g. fed to isoTimeToHours). We use toFormat, NOT toLocaleString: some
 * locales (fr) render a localized time like "14 h 30", which would break a
 * downstream "HH:mm" parser. #4204.
 */
export function formatHourMinute24(dt: DateTime): string {
  return dt.toFormat('HH:mm');
}

/** Fixed "HH:mm:ss" 24-hour timestamp, for log lines. */
export function formatLogTimestamp(dt: DateTime): string {
  return dt.toFormat('HH:mm:ss');
}
